import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CardsState } from './model';
import { CARDS_ACTIONS, CARDS_LOADERS } from './utils';
import { PaymentMethod } from '@stripe/stripe-js';

const initialState: CardsState = {
  loaders: {},
};

export const cardsSlice = createSlice({
  name: 'cards',
  initialState,
  reducers: {
    reset: () => initialState,
    setCards: (state, { payload }: PayloadAction<PaymentMethod[]>) => {
      state.cards = payload;
    },
    toggleLoader: (
      state,
      {
        payload: { key, value },
      }: PayloadAction<{ key: CARDS_LOADERS; value: boolean }>,
    ) => {
      state.loaders[key] = value;
    },
  },
});

const extraActions = {
  getAllCards: createAction(CARDS_ACTIONS.GET_CARDS),
  removeMethod: createAction<string>(CARDS_ACTIONS.DELETE_PAYMENT_METHOD),
};

export const { reset, toggleLoader, getAllCards, setCards, removeMethod } = {
  ...cardsSlice.actions,
  ...extraActions,
};

export const cardsReducer = cardsSlice.reducer;
